import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UnprocessClaimsProvComponent} from './unprocess-claims-prov/unprocess-claims-prov.component';
import {PaymentsProvComponent} from './payments-prov/payments-prov.component';
import {DenialsProvComponent} from './denials-prov/denials-prov.component';
import {ProcessedClaimsProvComponent} from './processed-claims-prov/processed-claims-prov.component';

const routes: Routes = [
    {
      path: 'v1',
        children: [
          { path: 'unprocessedClaims', component: UnprocessClaimsProvComponent, data: { title: 'Unprocessed Claims' } },
          { path: 'processedClaims', component: ProcessedClaimsProvComponent, data: { title: 'Processed Claims'} },
          { path: 'payments', component: PaymentsProvComponent, data: { title: 'Payments'} },
          { path: 'providerDenials', component: DenialsProvComponent, data: { title: 'Provider Denials'} },
        ]
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class BillingProviderRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/billing-provider-routing.module.ts